import { getEnvironmentConstant } from './utilities';
import { CART_COUNT_URL, PROD_ENV } from './constants';

const defaultCartCookie = 'cartReference';

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return undefined;
};

/**
 * The cart application uses 2 different cookies cartReference and cartReferenceStage
 * for production and staging respectively.  So we check the env attribute
 * to determine which to use
 * @returns {string}
 */
export const getCartCookie = (env) => {
  let cookieName = defaultCartCookie;
  if (env !== PROD_ENV) {
    cookieName += 'Stage';
  }
  return getCookie(cookieName);
};

export const getCartCountUrl = (env) => {
  const cartId = getCartCookie(env);
  return (cartId ? getEnvironmentConstant({ key: CART_COUNT_URL, env }).replace('{{cartId}}', cartId) : false);
};
